export default __webpack_public_path__ + "static/media/hht2_ep01_timeline_03.ef6897fa.png";